<template>
    <div>
        <div class="mb-3 d-flex align-items-center">
            <div class="mr-2 text-title">{{ title }}</div>
            <div class="ml-auto">
                <el-radio-group v-model="financialratioshowtype" size="small">
                    <el-radio-button size="small" label="table"><i class="el-icon-s-fold"></i></el-radio-button>
                    <el-radio-button size="small" label="barchart"><i class="el-icon-s-data"></i></el-radio-button>
                    <el-radio-button size="small" label="linechart"><i class="el-icon-share"></i></el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div>
            <div v-if="financialratioshowtype=='barchart'">
                <BarChart :data="chartdata" :width="barChartSizeTop.width" :height="302"/>
            </div>
            <div v-if="financialratioshowtype=='linechart'" class="mt-4">
                <LineChart :data="chartdata" :width="barChartSizeTop.width" :height="110"/>
            </div>
            <table v-if="financialratioshowtype=='table'" id="table-covenant" class="table-bordered table-striped table-hover" style="width: 100%;">
                <thead>
                    <tr>
                        <td>FINANCIAL RATIO</td>
                        <td class="text-center">KRITERIA</td>
                        <td class="text-center">Jan</td>
                        <td class="text-center">Feb</td>
                        <td class="text-center">Mar</td>
                        <td class="text-center">Apr</td>
                        <td class="text-center">May</td>
                        <td class="text-center">Jun</td>
                        <td class="text-center">Jul</td>
                        <td class="text-center">Aug</td>
                        <td class="text-center">Sep</td>
                        <td class="text-center">Oct</td>
                        <td class="text-center">Nov</td>
                        <td class="text-center">Dec</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in tabledata" :key="index">
                        <td><b>{{ item.title }}</b></td>
                        <td class="text-center">{{ decodeHTML(item.criteria) }}</td>
                        <td class="text-right" :style="covenantColor(item.jan, index)">{{ formatNum(item.jan) }}%</td>
                        <td class="text-right" :style="covenantColor(item.feb, index)">{{ formatNum(item.feb) }}%</td>
                        <td class="text-right" :style="covenantColor(item.mar, index)">{{ formatNum(item.mar) }}%</td>
                        <td class="text-right" :style="covenantColor(item.apr, index)">{{ formatNum(item.apr) }}%</td>
                        <td class="text-right" :style="covenantColor(item.may, index)">{{ formatNum(item.may) }}%</td>
                        <td class="text-right" :style="covenantColor(item.jun, index)">{{ formatNum(item.jun) }}%</td>
                        <td class="text-right" :style="covenantColor(item.jul, index)">{{ formatNum(item.jul) }}%</td>
                        <td class="text-right" :style="covenantColor(item.aug, index)">{{ formatNum(item.aug) }}%</td>
                        <td class="text-right" :style="covenantColor(item.sep, index)">{{ formatNum(item.sep) }}%</td>
                        <td class="text-right" :style="covenantColor(item.oct, index)">{{ formatNum(item.oct) }}%</td>
                        <td class="text-right" :style="covenantColor(item.nov, index)">{{ formatNum(item.nov) }}%</td>
                        <td class="text-right" :style="covenantColor(item.dec, index)">{{ formatNum(item.dec) }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Treasury from '@/components/page/Treasury.js'
import BarChart from '@/components/chart/BarChart.js'
import LineChart from '@/components/chart/LineChart.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import { CovenantPosition } from '@/data/treasury/Covenant.js'
import { RatioPosition } from '@/data/treasury/FinancialRatio.js'

export default {
    extends: Treasury,
    components:{ BarChart, LineChart },
    props: {
        id: {
            type: String,
            default: '',
            //required: false,
        }
    },
    setup() {
        
    },
    mounted() {
        //this.setCovenantData()
        //
        this.getData()
    },
    data() {
        return {
            title: 'FINANCIAL COVENANT ' + Penanggalan().tahun,
            tabledata: [],
            chartdata: [],
            financialratioshowtype: 'table',
            barChartSizeTop: {
				width:500,
				height:200,
			},
            loading : {
                table: true,
                chart: true,
            }
        }
    }, 
    methods: {
        setCovenantData() {
			this.tabledata = CovenantPosition;
			this.chartdata = this.processBarChart(RatioPosition, "Label", "", "Nilai", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
		},
        financialRatioShow(type) {
			this.financialratioshowtype = type			
		},

        async getData() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/treasury/financialratio?'

			//this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			//this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')
			//this.urlRequestParams+='&tahun='+this.year

			this.loading.table = true;
			this.loading.chart = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					let balanceData = response.data.data.data;
					this.title = response.data.data.title.toUpperCase();
                    //this.setCashNonCashData(balanceData)
                    //console.log(JSON.stringify(balanceData));
                    if(response.data.data.data_chart) {
                        this.chartdata = this.processBarChart(response.data.data.data_chart, "Label", "", "Nilai", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
                    }

                    if(response.data.data.data_table) {
                        this.tabledata = response.data.data.data_table;
                    }
                })
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.chart = false;
					this.loading.table = false;
				})

        },

        covenantColor(val,index) {
			let style = '';
			if(index==0) {
				if(val >= 100) {
					style += 'color:green;'
				} else {
					style += 'color:red;'
				}
			} else if(index==1) {
				if(val <= 300) {
					style += 'color:green;'
				} else {
					style += 'color:red;'
				}
			} else if(index==2) {
				if(val >= 100) {
					style += 'color:green;'
				} else {
					style += 'color:red;'
				}
			}
			return style
		},

        decodeHTML(html) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            return tempDiv.textContent || tempDiv.innerText || '';
        },
		
    }
}
</script>

<style>

</style>